import React from 'react';
import { PropTypes } from 'prop-types';
import config from 'config';

import './Background.css';
import Banner from './Banner';

const Background = ({ children, isLanding, fixedHeight }) => {
  return (
    <div
      className={`container${isLanding ? ' landing-gradient' : ''}${fixedHeight ? ' fixed-height' : ''}`}
    >
      {config?.banner?.display === 'true' && <Banner />}
      {children}
    </div>
  );
};

Background.propTypes = {
  isLanding: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  children: PropTypes.any,
};

export default Background;
